import HomeHeader from "containers/Home/HomeHeader/HomeHeader";
import React from "react";
import UserDetailsHeader from "../UserDetails/UserDetailsHeader/UserDetailsHeader";
import "../VerifyOtp/VerifyOtp.css";
import InputBar from "components/InputBar/InputBar";
import SelectInput from "components/SelectInput/SelectInput";
import Button from "components/Button/Button";

function VerifyOtp() {
  return (
    <>
      <UserDetailsHeader vmName={"logo"} />
      <section className="flex-container-space-between">
        <div>
          <p>Your 4 digit OTP is sent to</p>
          <span>+91-9654627814</span>
        </div>
        <div className="edit_number">
          <br />
          <br />
          <span>Edit Number</span>
        </div>
      </section>
      <section className="flex-container-space-between">
        <div className="input-area">
          <InputBar
            type="text"
            customClassName="input-bar"
            value={""}
            // onChange={mobileNumberChangeHandler}
            inputProps={{}}
          />
        </div>
        <div className="input-area">
          <InputBar
            type="text"
            customClassName="input-bar"
            value={""}
            // onChange={mobileNumberChangeHandler}
            inputProps={{}}
          />
        </div>
        <div className="input-area">
          <InputBar
            type="text"
            customClassName="input-bar"
            value={""}
            // onChange={mobileNumberChangeHandler}
            inputProps={{}}
          />
        </div>
        <div className="input-area">
          <InputBar
            type="text"
            customClassName="input-bar"
            value={""}
            // onChange={mobileNumberChangeHandler}
            inputProps={{}}
          />
        </div>
      </section>
      <section className="flex-container-space-between resent-otp">
        <div>
          <p>Resent OTP</p>
        </div>
        <div>
          <span>50:01</span>
        </div>
      </section>
      <section className="flex-container-Verify-otp">
        <div className="user-details-button">
          <Button onClick={() => console.log("demo functions")}>
            continue
          </Button>
        </div>
      </section>
    </>
  );
}
export default VerifyOtp;
